import axios, { type AxiosInstance } from "axios"
import config from "config"
import type { ITrainingReport } from "types/trainingReportTypes"
import authService from "./authService"

class TrainingReportService {
  private http: AxiosInstance

  public constructor() {
    this.http = axios.create({
      baseURL: config.apiUrl,
      headers: {
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    })
  }

  public getUserTrainingReports = async (userId: string): Promise<Array<ITrainingReport>> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.get<Array<ITrainingReport>>(
      `/user/${userId}/trainingreport`,
      config,
    )

    return data
  }

  public getTrainingReport = async (trainingReportId: string): Promise<ITrainingReport> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.get<ITrainingReport>(
      `/trainingreport/${trainingReportId}`,
      config,
    )

    return data
  }
}

const trainingReportService = new TrainingReportService()

export default trainingReportService
